import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getListing } from '../services/listingService';

const ListingPage = () => {
  const { id } = useParams();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const fetchListing = async () => {
      try {
        const data = await getListing(id);
        setListing(data);
      } catch (err) {
        setError('Failed to load listing');
      } finally {
        setLoading(false);
      }
    };

    fetchListing();
  }, [id]);

  const handleClick = () => {
    if (listing?.url) {
      window.open(listing.url, '_blank', 'noopener,noreferrer');
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!listing) return <div>Listing not found</div>;

  return (
    <div 
      className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex items-center mb-6">
        {listing.image && !imageError && (
          <img 
            src={listing.image} 
            alt={listing.name}
            className="w-24 h-24 rounded-full object-cover mr-6"
            onError={() => setImageError(true)}
          />
        )}
        <h1 className="text-3xl font-bold text-gray-900">{listing.name}</h1>
      </div>

      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Description</h2>
          <p className="text-gray-600">{listing.description}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Contact Information</h2>
            <div className="space-y-2">
              {listing.email && (
                <p className="text-gray-600">
                  <span className="font-medium">Email:</span> {listing.email}
                </p>
              )}
              {listing.location && (
                <p className="text-gray-600">
                  <span className="font-medium">Location:</span> {listing.location}
                </p>
              )}
            </div>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Details</h2>
            <div className="space-y-2">
              <p className="text-gray-600">
                <span className="font-medium">Category:</span> {listing.category}
              </p>
              <a 
                href={listing.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-secondary inline-flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(listing.url, '_blank', 'noopener,noreferrer');
                }}
              >
                Visit Website
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingPage;
